import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function tokenRefresh(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/fiscalize-device/${id}/token-refresh`, options)
        .then(response => {
            let cashRegister = jsona.deserialize(response.data);
            delete cashRegister.links;
            return cashRegister;
        });
}

function getDevice(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/fiscalize-device/${id}/get-device`, options)
        .then(response => {
            let cashRegister = jsona.deserialize(response.data);
            delete cashRegister.links;
            return cashRegister;
        });
}

function add(cashRegister) {
    const payload = jsona.serialize({
        stuff: cashRegister,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/fiscalize-device/${cashRegister.device_id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

export default {
    tokenRefresh,
    getDevice,
    add
};